export default __webpack_public_path__ + "static/media/declined-black.a694892b.svg";